import * as BABYLON from "@babylonjs/core/Legacy/legacy";

import { GameScene } from "./scene.js";

// ---全局---
const log = console.log.bind(console);
let currentScene: GameScene = null;

// 创建引擎的套路代码
function createEngine(canvas) {
	let en = new BABYLON.Engine(canvas, true, {
		preserveDrawingBuffer: true,
		stencil: true,
		disableWebGL2Support: false,
	});

	// 窗口调整大小时跟随调整画面
	window.addEventListener("resize", function () {
		en.resize();
	});
	return en;
}

// 这个函数是启动引擎用的
function startRenderLoop(engine: BABYLON.Engine, scene: GameScene) {
	engine.runRenderLoop(function () {
		if (scene) {
			scene.render();
		}
	});
}

function setupDebugUi(canvas: Element, engine: BABYLON.Engine) {
	// 绑定按钮
	let btn = document.querySelector("#btn-restart");
	btn.addEventListener("click", function (event) {
		let canvas = document.querySelector("#id-canvas") as HTMLCanvasElement;
		canvas.focus();
		let scene = new GameScene(engine, canvas, currentScene.GetAsset());
		scene.start();
		scene.tryStart();

		// 放在 window 全局变量里，方便 debug
		window.engine = engine;
		window.scene = scene.bbScene;

		engine.stopRenderLoop();

		// 启动引擎
		startRenderLoop(engine, scene);

		currentScene = scene;
	});
}

const __main = async function () {
	const canvas = document.querySelector("#id-canvas");
	const engine = createEngine(canvas);
	const scene = new GameScene(engine, canvas);
	scene.start();

	currentScene = scene;

	// 放在 window 全局变量里，方便 debug
	window.engine = engine;
	window.scene = scene.bbScene;

	// 加按钮调试
	setupDebugUi(canvas, engine);

	// 启动引擎
	startRenderLoop(engine, scene);
};

__main();
